import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CardMaster from 'components/Product/CardMaster';
import Typography from '@mui/material/Typography';
import { useProduct } from 'effects/useProduct';
import { PRODUCT_HANDLE } from 'utilities/constants';

interface NoResultDisplayProps {
  searchQuery?: string;
}

const NoResults: React.FC<NoResultDisplayProps> = ({ searchQuery }) => {
  const { product } = useProduct(PRODUCT_HANDLE.CARD_GIFT);

  return (
    <Stack alignItems="center" spacing={2} sx={{ pb: 6 }}>
      <Stack direction="row" justifyContent="center">
        <Typography variant="h3">We couldn't find any cards matching your search</Typography>
      </Stack>
      <Box sx={{ typography: 'subtitle1', color: 'text.secondary', textAlign: 'center' }}>Please check your spelling or try different keywords.</Box>
      <Box sx={{ pt: 6, pb: 3, typography: 'subtitle1', textAlign: 'center' }}>Otherwise, consider the Card.Gift choice card, which turns into one or more gift cards from 150+ top brands</Box>
      <Stack>{product && <CardMaster size="small" noShrink item={product} />}</Stack>
    </Stack>
  );
};

export default NoResults;
